
export interface ThemeItem {
  id: string;
  name: string;
  englishName: string;
  slogan: string;
  description: string;
  color: string;
  accentColor: string;
  icon: string;
  image: string;
  heroImage: string;
  tags: string[];
  highlights: string[];
  destinations: {
    id: string;
    name: string;
    image: string;
    tags: string[];
  }[];
  itineraries: {
    id: string;
    title: string;
    days: string;
    highlights: string[];
    image: string;
    hot: boolean;
  }[];
  tips: {
    title: string;
    content: string;
    icon: string;
  }[];
  cases: {
    title: string;
    client: string;
    description: string;
    image: string;
    tags: string[];
  }[];
  advantages: {
    icon: string;
    title: string;
    desc: string;
  }[];
}

export const themes: ThemeItem[] = [
  {
    id: 'polar',
    name: '极地探险',
    englishName: 'Polar Expedition',
    slogan: '踏上地球两极，感受生命的极限之美',
    description: '自由旷野深耕极地旅行10年，创始人亲自带队南北极12次，累计服务超1000人次。我们与海达路德、庞洛、赫伯罗特等顶级极地邮轮深度合作，为您打造最专业、最安全、最震撼的极地探险体验。从南极半岛的企鹅群落到北极斯瓦尔巴的北极熊，每一次极地之旅都是一次生命的洗礼。',
    color: '#1a3a5c',
    accentColor: '#7ec8e8',
    icon: 'ri-compass-3-line',
    image: 'https://readdy.ai/api/search-image?query=Antarctica%20polar%20expedition%20icebergs%20dramatic%20blue%20white%20landscape%20penguins%20expedition%20ship%20pristine%20wilderness%20cinematic%20photography%20ultra%20wide&width=800&height=560&seq=theme_polar_card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=Antarctica%20South%20Pole%20dramatic%20icebergs%20glaciers%20blue%20ice%20pristine%20polar%20landscape%20expedition%20adventure%20cinematic%20wide%20angle%20photography%20golden%20light&width=1920&height=900&seq=theme_polar_hero&orientation=landscape',
    tags: ['南极探险', '北极探险', '极地邮轮', '企鹅观察', '北极熊', '极光追踪'],
    highlights: [
      '10年极地深耕，创始人亲自带队12次南北极',
      '与顶级极地邮轮长期合作，优先舱位协调',
      '专业极地生物学家随船讲解，深度解读极地生态',
      '登陆南极大陆，踏上地球最南端的土地',
      '北极斯瓦尔巴群岛，近距离观察北极熊',
      '极地皮划艇、雪地徒步等沉浸式体验',
    ],
    destinations: [
      {
        id: 'antarctica',
        name: '南极半岛',
        image: 'https://readdy.ai/api/search-image?query=Antarctica%20peninsula%20icebergs%20penguins%20pristine%20polar%20landscape%20blue%20white%20dramatic%20sky%20expedition&width=400&height=280&seq=polar_dest1&orientation=landscape',
        tags: ['企鹅群落', '冰川徒步', '极地邮轮'],
      },
      {
        id: 'arctic',
        name: '北极斯瓦尔巴',
        image: 'https://readdy.ai/api/search-image?query=Arctic%20Svalbard%20polar%20bear%20sea%20ice%20dramatic%20landscape%20midnight%20sun%20expedition%20photography&width=400&height=280&seq=polar_dest2&orientation=landscape',
        tags: ['北极熊', '午夜阳光', '北极狐'],
      },
      {
        id: 'greenland',
        name: '格陵兰岛',
        image: 'https://readdy.ai/api/search-image?query=Greenland%20massive%20glacier%20iceberg%20fjord%20dramatic%20arctic%20landscape%20blue%20ice%20pristine%20wilderness&width=400&height=280&seq=polar_dest3&orientation=landscape',
        tags: ['冰盖徒步', '峡湾探索', '因纽特文化'],
      },
    ],
    itineraries: [
      {
        id: 'polar-01',
        title: '南极半岛经典探险11天',
        days: '11天9晚',
        highlights: ['乌斯怀亚出发', '德雷克海峡穿越', '南极半岛登陆5次', '企鹅群落近距离观察'],
        image: 'https://readdy.ai/api/search-image?query=Antarctica%20zodiac%20boat%20approaching%20icebergs%20penguins%20on%20ice%20dramatic%20polar%20landscape%20blue%20sky%20reflection%20calm%20water%20expedition&width=600&height=380&seq=polar_itin1&orientation=landscape',
        hot: true,
      },
      {
        id: 'polar-02',
        title: '南极圈深度穿越16天',
        days: '16天14晚',
        highlights: ['穿越南极圈', '南乔治亚岛', '福克兰群岛', '王企鹅栖息地'],
        image: 'https://readdy.ai/api/search-image?query=Antarctica%20circle%20crossing%20expedition%20ship%20massive%20icebergs%20dramatic%20polar%20sunset%20orange%20sky%20reflection%20pristine%20wilderness&width=600&height=380&seq=polar_itin2&orientation=landscape',
        hot: true,
      },
      {
        id: 'polar-03',
        title: '北极斯瓦尔巴探险10天',
        days: '10天8晚',
        highlights: ['北极熊追踪', '午夜阳光', '北极狐观察', '冰川徒步'],
        image: 'https://readdy.ai/api/search-image?query=Arctic%20Svalbard%20polar%20bear%20on%20sea%20ice%20dramatic%20arctic%20landscape%20midnight%20sun%20expedition%20photography%20wildlife&width=600&height=380&seq=polar_itin3&orientation=landscape',
        hot: false,
      },
      {
        id: 'polar-04',
        title: '南极摄影专属团14天',
        days: '14天12晚',
        highlights: ['专业摄影师带队', '最佳拍摄机位', '摄影工作坊', '独家登陆点'],
        image: 'https://readdy.ai/api/search-image?query=Antarctica%20photography%20expedition%20golden%20hour%20light%20penguins%20icebergs%20dramatic%20clouds%20professional%20wildlife%20photography%20pristine%20nature&width=600&height=380&seq=polar_itin4&orientation=landscape',
        hot: false,
      },
    ],
    tips: [
      {
        title: '最佳出行时间',
        content: '南极：11月至次年3月（南半球夏季）；北极：6月至8月（极昼期）。提前3-6个月预订，热门船期极易售罄。',
        icon: 'ri-calendar-line',
      },
      {
        title: '装备准备',
        content: '防水冲锋衣（-20°C以上）、保暖内衣套装、防水徒步靴、太阳镜（防紫外线）、防水手套为必备装备。',
        icon: 'ri-suitcase-line',
      },
      {
        title: '身体准备',
        content: '出发前需完成体检，确保身体状况适合极地探险。晕船药建议提前准备，德雷克海峡风浪较大。',
        icon: 'ri-heart-pulse-line',
      },
      {
        title: '摄影建议',
        content: '相机建议携带防水袋，低温环境注意电池保暖。长焦镜头（300mm以上）拍摄野生动物必备。',
        icon: 'ri-camera-line',
      },
    ],
    cases: [
      {
        title: '张总一家南极亲子探险',
        client: '企业家家庭·4人出行',
        description: '为张总一家量身定制南极半岛11天亲子探险，安排专属中文讲解员，孩子们在企鹅栖息地近距离互动，全程野奢邮轮入住，创造了一段终生难忘的家庭记忆。',
        image: 'https://readdy.ai/api/search-image?query=family%20expedition%20Antarctica%20penguins%20children%20parents%20watching%20wildlife%20pristine%20polar%20landscape%20adventure%20travel&width=600&height=380&seq=polar_case1&orientation=landscape',
        tags: ['亲子定制', '南极半岛', '11天', '野奢邮轮'],
      },
      {
        title: '某科技公司高管团北极考察',
        client: '互联网企业·12人团队',
        description: '为某头部科技公司高管团定制北极斯瓦尔巴10天考察之旅，结合极地生态讲座与团队建设活动，在极地荒野中激发创新思维，深受客户好评。',
        image: 'https://readdy.ai/api/search-image?query=Arctic%20expedition%20group%20corporate%20team%20building%20polar%20landscape%20adventure%20professional%20team%20outdoor%20activity&width=600&height=380&seq=polar_case2&orientation=landscape',
        tags: ['企业定制', '北极探险', '10天', '团队建设'],
      },
    ],
    advantages: [
      { icon: 'ri-award-line', title: '10年极地深耕', desc: '创始人亲自带队南北极12次，累计服务超1000人次' },
      { icon: 'ri-ship-2-line', title: '顶级邮轮合作', desc: '与海达路德、庞洛等极地邮轮长期合作，优先舱位' },
      { icon: 'ri-user-star-line', title: '专业随行团队', desc: '极地生物学家、中文讲解员、摄影师全程随行' },
      { icon: 'ri-shield-check-line', title: '安全保障', desc: '完善的极地安全预案，24小时应急响应机制' },
    ],
  },
  {
    id: 'safari',
    name: '非洲 Safari',
    englishName: 'Africa Safari',
    slogan: '重返非洲旷野，邂逅生命本真',
    description: '非洲大草原是地球上最后一片真正意义上的野生动物天堂。自由旷野深度合作坦桑尼亚、肯尼亚、纳米比亚顶级野奢营地，为您打造从动物大迁徙追踪到野奢帐篷营地的全链路非洲Safari体验。每一次日出游猎，都是与大自然最真实的对话。',
    color: '#5a3a10',
    accentColor: '#e8c87e',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=Africa%20Safari%20Serengeti%20savanna%20sunset%20acacia%20tree%20silhouette%20lion%20pride%20golden%20hour%20dramatic%20sky%20wildlife%20photography%20cinematic&width=800&height=560&seq=theme_safari_card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=Africa%20Serengeti%20great%20migration%20wildebeest%20crossing%20Mara%20river%20dramatic%20golden%20sunset%20African%20savanna%20wildlife%20photography%20cinematic%20wide%20angle&width=1920&height=900&seq=theme_safari_hero&orientation=landscape',
    tags: ['动物大迁徙', '野奢营地', '五大兽', '热气球Safari', '马赛文化', '桑给巴尔'],
    highlights: [
      '全程入住顶级野奢帐篷营地，在荒野中享受奢华',
      '专业向导带领，追踪非洲五大兽（狮、豹、象、犀、水牛）',
      '热气球Safari，俯瞰塞伦盖蒂大草原',
      '动物大迁徙最佳观赏期专属团期',
      '马赛族文化深度体验，走进真实非洲',
      '坦桑尼亚+桑给巴尔海岛双体验',
    ],
    destinations: [
      {
        id: 'tanzania',
        name: '坦桑尼亚',
        image: 'https://readdy.ai/api/search-image?query=Tanzania%20Serengeti%20wildebeest%20migration%20thousands%20animals%20crossing%20river%20dramatic%20wildlife%20photography%20golden%20light&width=400&height=280&seq=safari_dest1&orientation=landscape',
        tags: ['动物大迁徙', '塞伦盖蒂', '恩戈罗恩戈罗'],
      },
      {
        id: 'kenya',
        name: '肯尼亚',
        image: 'https://readdy.ai/api/search-image?query=Kenya%20Masai%20Mara%20safari%20game%20drive%20jeep%20lion%20cheetah%20dramatic%20African%20savanna%20golden%20sunset%20wildlife&width=400&height=280&seq=safari_dest2&orientation=landscape',
        tags: ['马赛马拉', '猎豹追踪', '马赛文化'],
      },
      {
        id: 'namibia',
        name: '纳米比亚',
        image: 'https://readdy.ai/api/search-image?query=Namibia%20Sossusvlei%20red%20sand%20dunes%20dramatic%20desert%20landscape%20dead%20trees%20sunrise%20cinematic%20photography&width=400&height=280&seq=safari_dest3&orientation=landscape',
        tags: ['沙漠探险', '埃托沙国家公园', '骷髅海岸'],
      },
    ],
    itineraries: [
      {
        id: 'safari-01',
        title: '坦桑尼亚野奢Safari精华10天',
        days: '10天8晚',
        highlights: ['塞伦盖蒂3晚', '恩戈罗恩戈罗', '热气球Safari', '顶级野奢营地'],
        image: 'https://readdy.ai/api/search-image?query=Tanzania%20Serengeti%20luxury%20safari%20camp%20tent%20sunset%20acacia%20tree%20silhouette%20golden%20hour%20African%20savanna%20wildlife&width=600&height=380&seq=safari_itin1&orientation=landscape',
        hot: true,
      },
      {
        id: 'safari-02',
        title: '肯尼亚马赛马拉追猎8天',
        days: '8天6晚',
        highlights: ['马赛马拉游猎', '猎豹追踪', '马赛族村落', '野奢营地'],
        image: 'https://readdy.ai/api/search-image?query=Kenya%20Masai%20Mara%20cheetah%20hunting%20dramatic%20African%20savanna%20golden%20light%20wildlife%20photography%20safari%20jeep&width=600&height=380&seq=safari_itin2&orientation=landscape',
        hot: true,
      },
      {
        id: 'safari-03',
        title: '坦桑尼亚+桑给巴尔奢野14天',
        days: '14天12晚',
        highlights: ['大迁徙追踪', '桑给巴尔海岛', '水下世界探索', '野奢+海岛双体验'],
        image: 'https://readdy.ai/api/search-image?query=Zanzibar%20island%20turquoise%20water%20white%20sand%20beach%20luxury%20overwater%20bungalow%20tropical%20paradise%20aerial%20view&width=600&height=380&seq=safari_itin3&orientation=landscape',
        hot: false,
      },
      {
        id: 'safari-04',
        title: '纳米比亚沙漠奇境10天',
        days: '10天8晚',
        highlights: ['苏丝斯黎红沙漠', '埃托沙国家公园', '骷髅海岸', '沙漠野奢营地'],
        image: 'https://readdy.ai/api/search-image?query=Namibia%20Sossusvlei%20red%20sand%20dunes%20dramatic%20desert%20landscape%20dead%20trees%20sunrise%20cinematic%20photography%20luxury%20camp&width=600&height=380&seq=safari_itin4&orientation=landscape',
        hot: false,
      },
    ],
    tips: [
      {
        title: '最佳出行时间',
        content: '坦桑尼亚大迁徙：6-10月（旱季）；肯尼亚马赛马拉：7-9月；纳米比亚：5-10月。旱季动物集中，游猎体验最佳。',
        icon: 'ri-calendar-line',
      },
      {
        title: '健康防护',
        content: '疫苗接种：黄热病疫苗（部分地区必须），疟疾预防药物出发前2周开始服用。建议购买含医疗救援的旅行保险。',
        icon: 'ri-heart-pulse-line',
      },
      {
        title: 'Safari着装',
        content: '建议卡其色、棕色等大地色系，避免鲜艳颜色。长袖长裤防晒防虫，清晨游猎需备薄外套。',
        icon: 'ri-t-shirt-line',
      },
      {
        title: '摄影装备',
        content: '长焦镜头（400mm以上）拍摄野生动物必备，双筒望远镜增强观察体验，防尘袋保护设备。',
        icon: 'ri-camera-line',
      },
    ],
    cases: [
      {
        title: '李总家庭非洲大迁徙追踪',
        client: '金融高管家庭·5人出行',
        description: '为李总一家定制坦桑尼亚14天野奢Safari，全程入住Four Seasons Safari Lodge等顶级营地，亲历动物大迁徙马拉河渡河，孩子们获得了最真实的自然教育体验。',
        image: 'https://readdy.ai/api/search-image?query=family%20safari%20Africa%20children%20watching%20wildebeest%20migration%20luxury%20camp%20sunset%20savanna%20wildlife%20adventure%20travel&width=600&height=380&seq=safari_case1&orientation=landscape',
        tags: ['家庭定制', '坦桑尼亚', '14天', '顶级野奢'],
      },
      {
        title: '某汽车品牌非洲主题活动',
        client: '知名汽车品牌·30人团队',
        description: '为某豪华汽车品牌策划非洲Safari主题高端客户活动，结合品牌越野精神与非洲荒野探险，在肯尼亚马赛马拉完成了一次令人难忘的品牌体验之旅。',
        image: 'https://readdy.ai/api/search-image?query=luxury%20SUV%20safari%20Africa%20savanna%20corporate%20event%20brand%20experience%20Kenya%20Masai%20Mara%20dramatic%20landscape&width=600&height=380&seq=safari_case2&orientation=landscape',
        tags: ['企业活动', '肯尼亚', '品牌体验', '30人团'],
      },
    ],
    advantages: [
      { icon: 'ri-home-heart-line', title: '顶级野奢营地', desc: '直连非洲顶级野奢营地，独家优惠与优先预订权' },
      { icon: 'ri-user-star-line', title: '专业Safari向导', desc: '持证专业向导，深度解读非洲野生动物行为' },
      { icon: 'ri-calendar-check-line', title: '最佳团期把控', desc: '精准把握大迁徙时间窗口，确保最佳观赏体验' },
      { icon: 'ri-route-line', title: '全链路定制', desc: '从落地接机到营地，从游猎到文化体验，一站式安排' },
    ],
  },
  {
    id: 'island',
    name: '野奢海岛',
    englishName: 'Luxury Island',
    slogan: '碧海白沙，奢享天涯',
    description: '自由旷野精选全球最顶级的野奢海岛目的地，从马尔代夫水上屋到塞舌尔私人岛屿，从巴厘岛悬崖别墅到帕劳水下世界，每一处都是远离尘嚣的奢华天堂。我们与全球顶级度假村深度合作，为您提供最优质的海岛奢华体验。',
    color: '#0a4a5a',
    accentColor: '#7ec8c8',
    icon: 'ri-anchor-line',
    image: 'https://readdy.ai/api/search-image?query=luxury%20overwater%20bungalow%20Maldives%20turquoise%20lagoon%20tropical%20paradise%20aerial%20view%20crystal%20clear%20water%20white%20sand%20beach%20sunset&width=800&height=560&seq=theme_island_card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=Maldives%20luxury%20resort%20overwater%20villa%20turquoise%20ocean%20tropical%20paradise%20aerial%20view%20dramatic%20sunset%20golden%20light%20pristine&width=1920&height=900&seq=theme_island_hero&orientation=landscape',
    tags: ['马尔代夫', '塞舌尔', '巴厘岛', '帕劳', '水上屋', '私人岛屿'],
    highlights: [
      '全球顶级野奢度假村长期合作，优先预订与专属礼遇',
      '私人岛屿定制，享受专属海岛奢华体验',
      '水上屋、海景别墅、悬崖泳池多种住宿选择',
      '潜水、浮潜、帆船等海上活动一站式安排',
      '米其林级别餐饮体验，海鲜盛宴',
      '蜜月、家庭、好友出行多种定制方案',
    ],
    destinations: [
      {
        id: 'maldives',
        name: '马尔代夫',
        image: 'https://readdy.ai/api/search-image?query=Maldives%20overwater%20bungalow%20turquoise%20lagoon%20tropical%20paradise%20aerial%20view%20crystal%20clear%20water%20white%20sand&width=400&height=280&seq=island_dest1&orientation=landscape',
        tags: ['水上屋', '珊瑚礁', '私人岛屿'],
      },
      {
        id: 'seychelles',
        name: '塞舌尔',
        image: 'https://readdy.ai/api/search-image?query=Seychelles%20La%20Digue%20island%20granite%20boulders%20turquoise%20water%20tropical%20beach%20paradise%20luxury&width=400&height=280&seq=island_dest2&orientation=landscape',
        tags: ['花岗岩奇石', '私人海滩', '稀有物种'],
      },
      {
        id: 'bali',
        name: '巴厘岛',
        image: 'https://readdy.ai/api/search-image?query=Bali%20cliff%20villa%20infinity%20pool%20ocean%20view%20tropical%20luxury%20resort%20sunset%20dramatic%20landscape&width=400&height=280&seq=island_dest3&orientation=landscape',
        tags: ['悬崖别墅', '神庙文化', '水稻梯田'],
      },
    ],
    itineraries: [
      {
        id: 'island-01',
        title: '马尔代夫顶奢水上屋7天',
        days: '7天5晚',
        highlights: ['顶级水上屋', '私人沙滩', '珊瑚礁潜水', '日落晚宴'],
        image: 'https://readdy.ai/api/search-image?query=Maldives%20luxury%20water%20villa%20sunset%20golden%20hour%20turquoise%20ocean%20tropical%20paradise%20romantic%20couple&width=600&height=380&seq=island_itin1&orientation=landscape',
        hot: true,
      },
      {
        id: 'island-02',
        title: '塞舌尔私人岛屿10天',
        days: '10天8晚',
        highlights: ['私人岛屿入住', '花岗岩奇石海滩', '稀有物种观察', '深海钓鱼'],
        image: 'https://readdy.ai/api/search-image?query=Seychelles%20private%20island%20luxury%20resort%20turquoise%20water%20granite%20boulders%20tropical%20paradise%20exclusive&width=600&height=380&seq=island_itin2&orientation=landscape',
        hot: true,
      },
      {
        id: 'island-03',
        title: '巴厘岛悬崖别墅蜜月8天',
        days: '8天6晚',
        highlights: ['悬崖无边泳池', '神庙日出', '水稻梯田', '传统SPA'],
        image: 'https://readdy.ai/api/search-image?query=Bali%20honeymoon%20cliff%20villa%20infinity%20pool%20sunset%20romantic%20luxury%20resort%20tropical%20flowers%20couple&width=600&height=380&seq=island_itin3&orientation=landscape',
        hot: false,
      },
    ],
    tips: [
      {
        title: '最佳出行时间',
        content: '马尔代夫：11月至次年4月（旱季）；塞舌尔：4-5月、10-11月；巴厘岛：4-10月（旱季）。',
        icon: 'ri-calendar-line',
      },
      {
        title: '签证须知',
        content: '马尔代夫：落地签，免费；塞舌尔：落地签，免费；巴厘岛：落地签，约35美元。均需有效护照。',
        icon: 'ri-passport-line',
      },
      {
        title: '海上活动',
        content: '潜水需提前考取PADI证书，浮潜无需证书。建议携带防水相机记录水下世界，防晒霜必备。',
        icon: 'ri-water-flash-line',
      },
      {
        title: '行李建议',
        content: '轻便夏装为主，备一件薄外套应对空调。防晒霜（SPF50+）、防晒衣、太阳镜必备。',
        icon: 'ri-luggage-cart-line',
      },
    ],
    cases: [
      {
        title: '王小姐马尔代夫蜜月定制',
        client: '新婚夫妇·2人出行',
        description: '为王小姐夫妇定制马尔代夫7天蜜月之旅，入住Soneva Jani顶级水上屋，安排私人沙滩晚宴、水下餐厅体验、日落帆船游，打造了一段完美的蜜月记忆。',
        image: 'https://readdy.ai/api/search-image?query=Maldives%20honeymoon%20couple%20romantic%20sunset%20overwater%20villa%20private%20beach%20dinner%20luxury%20tropical%20paradise&width=600&height=380&seq=island_case1&orientation=landscape',
        tags: ['蜜月定制', '马尔代夫', '7天', '顶级水上屋'],
      },
    ],
    advantages: [
      { icon: 'ri-vip-crown-line', title: '顶级度假村合作', desc: '与全球多家顶级度假村长期合作，提供专属礼遇与优先预订' },
      { icon: 'ri-heart-line', title: '蜜月专属服务', desc: '专属蜜月布置、私人晚宴、惊喜安排，打造完美浪漫' },
      { icon: 'ri-customer-service-2-line', title: '24小时管家', desc: '专属旅行管家全程陪伴，随时响应任何需求' },
      { icon: 'ri-plane-line', title: '全程无忧', desc: '接送、住宿、活动一站式安排，轻松出行' },
    ],
  },
  {
    id: 'cruise',
    name: '奢华邮轮',
    englishName: 'Luxury Cruise',
    slogan: '海上移动宫殿，探索世界的优雅方式',
    description: '奢华邮轮是探索世界最优雅的方式。自由旷野与丽晶七海、银海邮轮、维京邮轮等顶级奢华邮轮深度合作，为您提供从地中海到北欧峡湾，从加勒比海到南极极地的全球顶级邮轮体验。每一艘邮轮都是一座移动的五星级酒店。',
    color: '#1a2a4a',
    accentColor: '#a8c8e8',
    icon: 'ri-ship-2-line',
    image: 'https://readdy.ai/api/search-image?query=luxury%20cruise%20ship%20Mediterranean%20sea%20sunset%20dramatic%20sky%20elegant%20ocean%20liner%20sailing%20blue%20water%20cinematic%20photography&width=800&height=560&seq=theme_cruise_card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=luxury%20cruise%20ship%20Norwegian%20fjord%20dramatic%20landscape%20mountains%20reflection%20calm%20water%20elegant%20ocean%20liner%20cinematic%20wide%20angle&width=1920&height=900&seq=theme_cruise_hero&orientation=landscape',
    tags: ['地中海邮轮', '北欧峡湾', '南极邮轮', '加勒比海', '丽晶七海', '银海邮轮'],
    highlights: [
      '与丽晶七海、银海邮轮等顶级邮轮长期合作',
      '全包式奢华邮轮，餐饮、娱乐、岸上游览全含',
      '地中海、北欧、南极、加勒比多条精品航线',
      '专属中文服务团队，全程无语言障碍',
      '港口岸上游览专业安排，深度体验当地文化',
      '邮轮+陆地组合行程，最大化旅行价值',
    ],
    destinations: [
      {
        id: 'mediterranean',
        name: '地中海',
        image: 'https://readdy.ai/api/search-image?query=Mediterranean%20cruise%20Santorini%20Greece%20blue%20dome%20white%20buildings%20dramatic%20cliffs%20sunset%20luxury%20travel&width=400&height=280&seq=cruise_dest1&orientation=landscape',
        tags: ['希腊群岛', '意大利海岸', '克罗地亚'],
      },
      {
        id: 'nordic-fjord',
        name: '北欧峡湾',
        image: 'https://readdy.ai/api/search-image?query=Norway%20fjord%20cruise%20dramatic%20mountains%20reflection%20calm%20water%20luxury%20ship%20scenic%20landscape&width=400&height=280&seq=cruise_dest2&orientation=landscape',
        tags: ['挪威峡湾', '极光追踪', '北极圈'],
      },
      {
        id: 'caribbean',
        name: '加勒比海',
        image: 'https://readdy.ai/api/search-image?query=Caribbean%20cruise%20turquoise%20water%20tropical%20island%20luxury%20ship%20white%20sand%20beach%20paradise%20aerial%20view&width=400&height=280&seq=cruise_dest3&orientation=landscape',
        tags: ['热带岛屿', '珊瑚礁', '海滩度假'],
      },
    ],
    itineraries: [
      {
        id: 'cruise-01',
        title: '地中海奢华邮轮12天',
        days: '12天10晚',
        highlights: ['丽晶七海邮轮', '希腊群岛', '意大利海岸', '全包式服务'],
        image: 'https://readdy.ai/api/search-image?query=Mediterranean%20luxury%20cruise%20Santorini%20Greece%20dramatic%20sunset%20blue%20dome%20white%20buildings%20elegant%20ship&width=600&height=380&seq=cruise_itin1&orientation=landscape',
        hot: true,
      },
      {
        id: 'cruise-02',
        title: '北欧峡湾极光邮轮10天',
        days: '10天8晚',
        highlights: ['挪威峡湾', '极光追踪', '北极圈穿越', '银海邮轮'],
        image: 'https://readdy.ai/api/search-image?query=Norway%20northern%20lights%20aurora%20borealis%20fjord%20cruise%20ship%20dramatic%20sky%20reflection%20mountains%20luxury%20travel&width=600&height=380&seq=cruise_itin2&orientation=landscape',
        hot: true,
      },
      {
        id: 'cruise-03',
        title: '南极极地探险邮轮16天',
        days: '16天14晚',
        highlights: ['极地探险船', '南极半岛登陆', '企鹅群落', '冰川皮划艇'],
        image: 'https://readdy.ai/api/search-image?query=Antarctica%20expedition%20cruise%20ship%20icebergs%20dramatic%20polar%20landscape%20penguins%20pristine%20wilderness%20adventure&width=600&height=380&seq=cruise_itin3&orientation=landscape',
        hot: false,
      },
    ],
    tips: [
      {
        title: '邮轮选择',
        content: '奢华邮轮（丽晶七海、银海）vs 探险邮轮（海达路德、庞洛）：前者注重船上体验，后者注重目的地探索。根据需求选择。',
        icon: 'ri-ship-2-line',
      },
      {
        title: '提前预订',
        content: '热门航线和舱位需提前6-12个月预订，早鸟优惠可节省20-30%。舱位越高，景观越好，体验越佳。',
        icon: 'ri-calendar-line',
      },
      {
        title: '行李规范',
        content: '奢华邮轮通常有正式晚宴，需备正装。行李重量限制相对宽松，但建议精简行李，避免超重。',
        icon: 'ri-luggage-cart-line',
      },
      {
        title: '岸上游览',
        content: '建议通过邮轮公司或专业旅行社预订岸上游览，确保准时返船。自行安排需注意返船时间。',
        icon: 'ri-map-pin-line',
      },
    ],
    cases: [
      {
        title: '陈总夫妇地中海蜜月邮轮',
        client: '企业高管夫妇·2人出行',
        description: '为陈总夫妇定制地中海12天蜜月邮轮之旅，入住丽晶七海最高级套房，安排希腊圣托里尼私人游艇、意大利阿马尔菲海岸专属导览，完美的蜜月体验。',
        image: 'https://readdy.ai/api/search-image?query=Mediterranean%20cruise%20couple%20romantic%20Santorini%20sunset%20luxury%20suite%20private%20yacht%20Greece%20honeymoon%20travel&width=600&height=380&seq=cruise_case1&orientation=landscape',
        tags: ['蜜月邮轮', '地中海', '12天', '丽晶七海'],
      },
    ],
    advantages: [
      { icon: 'ri-ship-2-line', title: '顶级邮轮合作', desc: '丽晶七海、银海、维京等顶级邮轮长期合作资源' },
      { icon: 'ri-translate-2', title: '中文专属服务', desc: '全程中文服务团队，无语言障碍的邮轮体验' },
      { icon: 'ri-map-2-line', title: '岸上游览专业安排', desc: '每个港口专业岸上游览，深度体验当地文化' },
      { icon: 'ri-price-tag-3-line', title: '价格优势', desc: '早鸟优惠、团体折扣，价格透明，无隐形消费' },
    ],
  },
  {
    id: 'nordic',
    name: '北欧秘境',
    englishName: 'Nordic Secrets',
    slogan: '极光之下，峡湾之间，寻找北欧的诗意',
    description: '北欧是地球上最接近天堂的地方。自由旷野深度覆盖挪威、冰岛、芬兰、瑞典四国，从挪威壮观的峡湾到冰岛的火山冰川，从芬兰的极光小屋到瑞典的群岛风光，每一处都是令人窒息的自然奇观。我们为您打造最深度、最私密的北欧秘境体验。',
    color: '#1a3a2a',
    accentColor: '#a8d898',
    icon: 'ri-landscape-line',
    image: 'https://readdy.ai/api/search-image?query=Norway%20northern%20lights%20aurora%20borealis%20fjord%20dramatic%20sky%20reflection%20mountains%20pristine%20wilderness%20cinematic%20photography&width=800&height=560&seq=theme_nordic_card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=Iceland%20northern%20lights%20aurora%20borealis%20dramatic%20sky%20green%20purple%20lights%20snow%20landscape%20pristine%20wilderness%20cinematic%20wide%20angle%20photography&width=1920&height=900&seq=theme_nordic_hero&orientation=landscape',
    tags: ['极光追踪', '挪威峡湾', '冰岛火山', '芬兰极光小屋', '驯鹿雪橇', '午夜阳光'],
    highlights: [
      '专业极光追踪团队，最大化极光观赏概率',
      '芬兰玻璃极光小屋，躺在床上看极光',
      '挪威峡湾深度游，乘船穿越世界最美峡湾',
      '冰岛火山冰川双重奇观，地球上最独特的地貌',
      '驯鹿雪橇、狗拉雪橇等北欧特色体验',
      '北欧设计酒店，感受斯堪的纳维亚美学',
    ],
    destinations: [
      {
        id: 'norway',
        name: '挪威',
        image: 'https://readdy.ai/api/search-image?query=Norway%20Geirangerfjord%20dramatic%20fjord%20mountains%20waterfall%20reflection%20calm%20water%20scenic%20landscape&width=400&height=280&seq=nordic_dest1&orientation=landscape',
        tags: ['盖朗厄尔峡湾', '极光', '午夜阳光'],
      },
      {
        id: 'iceland',
        name: '冰岛',
        image: 'https://readdy.ai/api/search-image?query=Iceland%20volcanic%20landscape%20geysers%20hot%20springs%20dramatic%20sky%20aurora%20borealis%20pristine%20wilderness&width=400&height=280&seq=nordic_dest2&orientation=landscape',
        tags: ['火山地貌', '冰川徒步', '蓝湖温泉'],
      },
      {
        id: 'finland',
        name: '芬兰',
        image: 'https://readdy.ai/api/search-image?query=Finland%20glass%20igloo%20aurora%20borealis%20northern%20lights%20snow%20forest%20romantic%20luxury%20winter%20experience&width=400&height=280&seq=nordic_dest3&orientation=landscape',
        tags: ['玻璃极光小屋', '驯鹿雪橇', '圣诞老人村'],
      },
    ],
    itineraries: [
      {
        id: 'nordic-01',
        title: '挪威峡湾+极光追踪10天',
        days: '10天8晚',
        highlights: ['盖朗厄尔峡湾', '特罗姆瑟极光', '卑尔根鱼市', '峡湾游船'],
        image: 'https://readdy.ai/api/search-image?query=Norway%20Tromso%20northern%20lights%20aurora%20borealis%20dramatic%20sky%20reflection%20fjord%20snow%20landscape%20winter&width=600&height=380&seq=nordic_itin1&orientation=landscape',
        hot: true,
      },
      {
        id: 'nordic-02',
        title: '冰岛环岛奇境8天',
        days: '8天6晚',
        highlights: ['黄金圈', '冰川徒步', '蓝湖温泉', '极光追踪'],
        image: 'https://readdy.ai/api/search-image?query=Iceland%20golden%20circle%20geyser%20eruption%20dramatic%20sky%20volcanic%20landscape%20pristine%20wilderness%20adventure&width=600&height=380&seq=nordic_itin2&orientation=landscape',
        hot: true,
      },
      {
        id: 'nordic-03',
        title: '芬兰玻璃小屋极光蜜月7天',
        days: '7天5晚',
        highlights: ['玻璃极光小屋', '驯鹿雪橇', '圣诞老人村', '冰雪城堡'],
        image: 'https://readdy.ai/api/search-image?query=Finland%20glass%20igloo%20aurora%20borealis%20northern%20lights%20romantic%20couple%20luxury%20winter%20forest%20snow&width=600&height=380&seq=nordic_itin3&orientation=landscape',
        hot: false,
      },
    ],
    tips: [
      {
        title: '极光追踪',
        content: '极光最佳观赏期：9月至次年3月，需晴天无云。建议在极光活跃区（特罗姆瑟、罗弗敦）停留3晚以上，提高观赏概率。',
        icon: 'ri-sparkling-line',
      },
      {
        title: '最佳出行时间',
        content: '极光季：9月-3月；午夜阳光：6-7月；峡湾最美：5-9月。根据目的选择最佳时间。',
        icon: 'ri-calendar-line',
      },
      {
        title: '保暖装备',
        content: '北欧冬季极寒，需备-30°C以上保暖外套、防水靴、保暖手套。芬兰极光小屋通常提供专业保暖服。',
        icon: 'ri-temp-cold-line',
      },
      {
        title: '货币与消费',
        content: '北欧消费较高，建议提前兑换当地货币或使用信用卡。挪威、冰岛、芬兰均接受Visa/Mastercard。',
        icon: 'ri-money-cny-circle-line',
      },
    ],
    cases: [
      {
        title: '赵女士北欧极光蜜月之旅',
        client: '新婚夫妇·2人出行',
        description: '为赵女士夫妇定制芬兰+挪威10天极光蜜月之旅，入住芬兰玻璃极光小屋，安排驯鹿雪橇、挪威峡湾游船，成功追踪到壮观极光，完美的蜜月体验。',
        image: 'https://readdy.ai/api/search-image?query=Finland%20Norway%20honeymoon%20couple%20aurora%20borealis%20glass%20igloo%20romantic%20winter%20luxury%20travel%20northern%20lights&width=600&height=380&seq=nordic_case1&orientation=landscape',
        tags: ['蜜月定制', '芬兰+挪威', '10天', '极光追踪'],
      },
    ],
    advantages: [
      { icon: 'ri-sparkling-2-line', title: '专业极光追踪', desc: '与当地极光专家合作，最大化极光观赏成功率' },
      { icon: 'ri-hotel-line', title: '特色住宿', desc: '玻璃极光小屋、冰雪酒店、峡湾木屋等独特住宿' },
      { icon: 'ri-route-line', title: '深度路线设计', desc: '避开旅游热点，探索北欧最原始的秘境角落' },
      { icon: 'ri-translate-2', title: '中文专属服务', desc: '全程中文导游，深度解读北欧文化与自然奇观' },
    ],
  },
  {
    id: 'ecology',
    name: '生态研学',
    englishName: 'Eco Education',
    slogan: '在自然中学习，让旅行成为最好的教育',
    description: '生态研学是自由旷野为亲子家庭和教育机构打造的特色旅行产品。我们与全球顶级自然保护区、科研机构合作，将专业的自然教育融入旅行体验，让孩子们在南极企鹅群落、非洲大草原、热带雨林中获得最真实的自然教育，培养对地球的热爱与责任感。',
    color: '#2a4a1a',
    accentColor: '#a8d878',
    icon: 'ri-leaf-line',
    image: 'https://readdy.ai/api/search-image?query=eco%20education%20children%20nature%20learning%20wildlife%20observation%20tropical%20rainforest%20family%20adventure%20travel%20photography&width=800&height=560&seq=theme_ecology_card&orientation=landscape',
    heroImage: 'https://readdy.ai/api/search-image?query=children%20family%20eco%20education%20nature%20learning%20wildlife%20Africa%20safari%20penguins%20Antarctica%20tropical%20rainforest%20adventure%20travel%20cinematic%20wide%20angle&width=1920&height=900&seq=theme_ecology_hero&orientation=landscape',
    tags: ['亲子研学', '自然教育', '生态保育', '科考体验', '野生动物', '环保意识'],
    highlights: [
      '与全球顶级自然保护区和科研机构合作',
      '专业自然教育导师随行，深度解读生态知识',
      '亲子互动体验，让孩子成为自然探索者',
      '南极企鹅群落、非洲大草原等顶级研学目的地',
      '科考体验：参与真实的野生动物监测项目',
      '培养环保意识，成为地球守护者',
    ],
    destinations: [
      {
        id: 'antarctica',
        name: '南极生态研学',
        image: 'https://readdy.ai/api/search-image?query=Antarctica%20eco%20education%20children%20penguins%20wildlife%20observation%20learning%20nature%20pristine%20polar%20landscape&width=400&height=280&seq=ecology_dest1&orientation=landscape',
        tags: ['企鹅生态', '极地科考', '气候变化'],
      },
      {
        id: 'tanzania',
        name: '非洲生态研学',
        image: 'https://readdy.ai/api/search-image?query=Africa%20eco%20education%20children%20safari%20wildlife%20observation%20learning%20nature%20savanna%20family%20adventure&width=400&height=280&seq=ecology_dest2&orientation=landscape',
        tags: ['野生动物', '生态系统', '马赛文化'],
      },
      {
        id: 'rainforest',
        name: '热带雨林研学',
        image: 'https://readdy.ai/api/search-image?query=tropical%20rainforest%20eco%20education%20children%20nature%20learning%20biodiversity%20canopy%20walkway%20adventure&width=400&height=280&seq=ecology_dest3&orientation=landscape',
        tags: ['生物多样性', '雨林探索', '昆虫观察'],
      },
    ],
    itineraries: [
      {
        id: 'ecology-01',
        title: '南极亲子生态研学14天',
        days: '14天12晚',
        highlights: ['企鹅生态讲座', '极地科考体验', '气候变化教育', '亲子互动'],
        image: 'https://readdy.ai/api/search-image?query=Antarctica%20family%20eco%20education%20children%20penguins%20wildlife%20observation%20learning%20nature%20pristine%20polar%20landscape%20adventure&width=600&height=380&seq=ecology_itin1&orientation=landscape',
        hot: true,
      },
      {
        id: 'ecology-02',
        title: '非洲Safari亲子研学10天',
        days: '10天8晚',
        highlights: ['野生动物追踪', '生态系统讲解', '马赛族文化', '自然摄影课'],
        image: 'https://readdy.ai/api/search-image?query=Africa%20family%20safari%20children%20wildlife%20observation%20learning%20nature%20savanna%20adventure%20eco%20education&width=600&height=380&seq=ecology_itin2&orientation=landscape',
        hot: true,
      },
      {
        id: 'ecology-03',
        title: '热带雨林生态探索8天',
        days: '8天6晚',
        highlights: ['雨林冠层探索', '生物多样性调查', '昆虫标本制作', '原住民文化'],
        image: 'https://readdy.ai/api/search-image?query=tropical%20rainforest%20eco%20education%20children%20nature%20learning%20biodiversity%20canopy%20walkway%20adventure%20family&width=600&height=380&seq=ecology_itin3&orientation=landscape',
        hot: false,
      },
    ],
    tips: [
      {
        title: '适合年龄',
        content: '南极研学建议8岁以上；非洲Safari建议6岁以上；热带雨林研学建议5岁以上。所有行程均配备儿童专属活动。',
        icon: 'ri-parent-line',
      },
      {
        title: '研学准备',
        content: '出发前建议阅读目的地相关科普书籍，准备观察日记本，培养孩子的观察记录习惯。',
        icon: 'ri-book-open-line',
      },
      {
        title: '安全保障',
        content: '所有研学行程配备专业急救人员，严格执行儿童安全规范，家长全程陪同，确保孩子安全。',
        icon: 'ri-shield-check-line',
      },
      {
        title: '教育成果',
        content: '每次研学结束后提供专业研学报告，记录孩子的学习成果和成长轨迹，可作为升学材料。',
        icon: 'ri-file-text-line',
      },
    ],
    cases: [
      {
        title: '某国际学校南极研学团',
        client: '国际学校·20名学生',
        description: '为某知名国际学校定制南极14天生态研学之旅，配备专业自然教育导师，学生们参与企鹅种群监测、冰川变化观测等科考项目，获得了最真实的极地生态教育体验。',
        image: 'https://readdy.ai/api/search-image?query=Antarctica%20school%20group%20students%20eco%20education%20penguins%20wildlife%20observation%20learning%20nature%20pristine%20polar%20landscape&width=600&height=380&seq=ecology_case1&orientation=landscape',
        tags: ['学校研学', '南极', '14天', '科考体验'],
      },
    ],
    advantages: [
      { icon: 'ri-graduation-cap-line', title: '专业教育团队', desc: '自然教育导师+野生动物专家，深度解读生态知识' },
      { icon: 'ri-microscope-line', title: '科考体验', desc: '参与真实科研项目，让孩子成为小小科学家' },
      { icon: 'ri-shield-check-line', title: '儿童安全保障', desc: '专业急救人员随行，严格儿童安全规范' },
      { icon: 'ri-file-text-line', title: '研学报告', desc: '专业研学成果报告，记录孩子成长轨迹' },
    ],
  },
];
